module.exports = __webpack_public_path__ + "img/index_icon6@2x.ca04b92d.png";